// Related Products Swiper初期化関数
let initRelatedProductsAttempts = 0;
const maxRelatedProductsAttempts = 100; // 最大5秒間試行

function initRelatedProductsSwiper() {
  initRelatedProductsAttempts++;

  if (typeof Swiper === "undefined") {
    if (initRelatedProductsAttempts < maxRelatedProductsAttempts) {
      // より短い間隔（20ms）で再試行
      requestAnimationFrame(initRelatedProductsSwiper);
    }
    return;
  }

  // デスクトップとモバイルのスライダーを別々に取得
  const desktopSwiperElements = document.querySelectorAll(
    ".product__related-products-desktop .swiper"
  );
  const mobileSwiperElements = document.querySelectorAll(
    ".product__related-products-mobile .swiper-mobile"
  );

  const allSwiperElements = [...desktopSwiperElements, ...mobileSwiperElements];
  if (!allSwiperElements.length) return;

  allSwiperElements.forEach((swiperElement, index) => {
    // 既に初期化済みの場合はスキップ
    if (swiperElement.swiper) return;

    // 各Swiperインスタンスに固有のクラスを追加
    const uniqueClass = `related-products-swiper-${index}`;
    swiperElement.classList.add(uniqueClass);

    new Swiper(`.${uniqueClass}`, {
      direction: "horizontal",
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 28,
      centeredSlides: true,
      autoplay: false,
      pagination: {
        el: swiperElement.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: swiperElement.querySelector(".swiper-button-next"),
        prevEl: swiperElement.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
    });
  });
}

// 即座に実行開始
initRelatedProductsSwiper();

// バックアップとして複数のタイミングでも実行
document.addEventListener("DOMContentLoaded", initRelatedProductsSwiper);
window.addEventListener("load", initRelatedProductsSwiper);
